import { render, staticRenderFns } from "./newinspection.vue?vue&type=template&id=39867221"
import script from "./newinspection.vue?vue&type=script&lang=js"
export * from "./newinspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports